import { Stack } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid-premium';
import { CircularProgress } from '@mui/material';
import { FC } from 'react';
import { MessageRotator, MessageRotatorProps } from '../../messageRotator/messageRotator.component';

export const Loading: FC<ILoading> = ({ isLongLoading, messagesForLongLoading }) => {
  return (
    <GridOverlay>
      <Stack justifyContent='center' alignItems='center' gap={1}>
        <CircularProgress />
        {isLongLoading && <MessageRotator uniqueMessages={messagesForLongLoading} />}
      </Stack>
    </GridOverlay>
  );
};

interface ILoading {
  isLongLoading: boolean;
  messagesForLongLoading?: MessageRotatorProps['uniqueMessages'];
}
